<template>
  <div class="full-body footer" flex fic fjc>
    <div class="w8 mw11 footer-layout" flex fis fjb>
      <div class="box2 w12 mb20 pb20 hided" flex fic fjb>
        <div>
          <a href="/agree" class="mr4"> 서비스 이용약관 </a>
          <span> | </span>
          <a href="/privacy" class="ml4"> 개인정보처리방침 </a>
        </div>
        <div>
          <a href="https://twitter.com/UPICK_twt">
            <img src="../assets/twitter_icon.png" alt="" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCHYS3hBmHNv_-Dj4f_m-nDA"
            class="ml20"
          >
            <img src="../assets/youtube_logo.png" alt="" />
          </a>
        </div>
      </div>
      <div class="box1">
        <div class="fs-14 bold">(주) 어헤드 코리아</div>
        <div class="mt8">
          주소 : 서울특별시 강남구 도산대로 12길 25-1, 5층
          <div>사업자등록번호 :784-88-02180</div>
          <div>제 2022-서울강남-05684 호</div>
        </div>
        <div class="mt20 pt20d pt20t pt2m">이메일 : help.upick@gmail.com</div>
        <div class="mt20 pt20 bold">
          Copyright (c) 2022 AHEAD Korea Corp. All rights reserved.
        </div>
      </div>
      <div class="box2 hidem hidet" flex fic fjb>
        <div>
          <a href="/agree" class="mr10"> 서비스 이용약관 </a>
          <span> | </span>
          <a href="/privacy" class="ml10"> 개인정보처리방침 </a>
        </div>
        <div>
          <a href="https://twitter.com/UPICK_twt">
            <img src="../assets/twitter_icon.png" alt="" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCHYS3hBmHNv_-Dj4f_m-nDA"
            class="ml20"
          >
            <img src="../assets/youtube_logo.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterLayout',
};
</script>

<style lang="scss">
@import './styles/module/mixin.device.scss';
.footer {
  padding-bottom: 74px;

  @include device-mobile() {
    padding-bottom: 44px !important;
  }

  @include device-tablet() {
    padding-bottom: 44px !important;
  }

  .footer-layout {
    margin-top: 77px;
    font-family: 'Roboto';
    font-style: normal;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.5px;

    @include device-mobile() {
      font-size: 12px;
      margin-top: 24px !important;
    }

    @include device-tablet() {
      margin-top: 24px !important;
    }

    .box1 {
      color: #e4e4e4;

      .address {
      }

      .email {
      }
    }

    .box2 {
      > div:first-child {
        margin-right: 51px;
      }
      a {
        color: #999999 !important;
      }
    }
  }
}
</style>
